import * as i0 from '@angular/core';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WINDOW } from '@noda-lib/utils/injection';

/**
 * @deprecated use only detect manager from managers module
 */
let UtilsChangeDetectionService = /*#__PURE__*/(() => {
  class UtilsChangeDetectionService {
    constructor() {
      this.detector$ = new Subject();
    }
    detectChanges() {
      this.detector$.next(null);
    }
    listenChangeDetection() {
      return this.detector$.asObservable();
    }
    static {
      this.ɵfac = function UtilsChangeDetectionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UtilsChangeDetectionService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UtilsChangeDetectionService,
        factory: UtilsChangeDetectionService.ɵfac
      });
    }
  }
  return UtilsChangeDetectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlatformService = /*#__PURE__*/(() => {
  class PlatformService {
    constructor(platformId) {
      this.platformId = platformId;
    }
    isBrowser() {
      return isPlatformBrowser(this.platformId);
    }
    isServer() {
      return isPlatformServer(this.platformId);
    }
    static {
      this.ɵfac = function PlatformService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlatformService)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PlatformService,
        factory: PlatformService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PlatformService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isEnabledLocalStorage(storage) {
  try {
    const isEnabled = Boolean(window[storage]);
    return isEnabled;
  } catch (e) {
    return false;
  }
}
class Storage {
  constructor() {
    this.storage = {};
  }
  setItem(key, value) {
    this.storage[key] = value;
  }
  getItem(key) {
    return this.storage[key] ?? null;
  }
  removeItem(key) {
    delete this.storage?.[key];
  }
  clear() {
    this.storage = {};
  }
  getKeys() {
    return Object.keys(this.storage);
  }
}
let UtilsStorageService = /*#__PURE__*/(() => {
  class UtilsStorageService {
    constructor(window) {
      this.window = window;
      this.storage = new Storage();
    }
    getStorage(storage = 'localStorage') {
      return isEnabledLocalStorage(storage) ? this.window[storage] : this.storage;
    }
    setItem(key, value, storage) {
      this.getStorage(storage).setItem(key, JSON.stringify(value));
    }
    getItem(key, storage, isParse = true) {
      const result = this.getStorage(storage).getItem(key);
      return isParse ? JSON.parse(result) : result;
    }
    removeItem(key, storage) {
      this.getStorage(storage).removeItem(key);
    }
    clear(storage) {
      this.getStorage(storage).clear();
    }
    getKeys(type) {
      const storage = this.getStorage(type);
      if ('getKeys' in storage) {
        return storage.getKeys();
      }
      return Object.keys(storage);
    }
    static {
      this.ɵfac = function UtilsStorageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UtilsStorageService)(i0.ɵɵinject(WINDOW));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UtilsStorageService,
        factory: UtilsStorageService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UtilsStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { PlatformService, UtilsChangeDetectionService, UtilsStorageService, isEnabledLocalStorage };
